import type { ExploreContentItemBasicInfoAllOf } from './exploreContentItemBasicInfoAllOf';
import type { ExploreContentItemBasicInfoAllOfTwo } from './exploreContentItemBasicInfoAllOfTwo';

export type ExploreContentItemBasicInfo = ExploreContentItemBasicInfoAllOf & ExploreContentItemBasicInfoAllOfTwo;
